import { Select, SelectChangeEvent, SelectProps } from '@mui/material'
import { forwardRef, useImperativeHandle, useState } from 'react'

interface MuiSelectProps extends Omit<SelectProps<any>, 'onChange'> {
  onChange: (event: SelectChangeEvent) => void
}

export interface MentemMuiSelectRef {
  reset: () => void
  setValue: (newValue: string) => void
  getValue: () => string
}

const MentemMuiSelect = forwardRef<MentemMuiSelectRef, MuiSelectProps>(
  ({ sx, MenuProps, onChange, ...props }, ref) => {
    const [value, setValue] = useState(props.value || '')

    useImperativeHandle(ref, () => ({
      setValue: (newValue: string) => setValue(newValue),
      getValue: () => value,
      reset: () => setValue(''),
    }))

    return (
      <Select
        onChange={(e) => {
          setValue(e.target.value)
          onChange(e)
        }}
        IconComponent={() => (
          <div
            style={{
              position: 'absolute',
              right: '12px',
              pointerEvents: 'none',
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.79289 8.79289C6.15338 8.43241 6.72061 8.40468 7.1129 8.7097L7.20711 8.79289L12.5 14.085L17.7929 8.79289C18.1534 8.43241 18.7206 8.40468 19.1129 8.7097L19.2071 8.79289C19.5676 9.15338 19.5953 9.72061 19.2903 10.1129L19.2071 10.2071L13.2071 16.2071C12.8466 16.5676 12.2794 16.5953 11.8871 16.2903L11.7929 16.2071L5.79289 10.2071C5.40237 9.81658 5.40237 9.18342 5.79289 8.79289Z"
                fill="#51597B"
              />
            </svg>
          </div>
        )}
        sx={{
          height: 38,
          width: '100%',
          borderRadius: 0,
          fontFamily: 'Clancy, sans-serif',
          textAlign: 'center',
          '& .MuiSelect-select': {
            textAlign: 'center',
          },
          ...sx,
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              borderRadius: 0,
              '& .MuiMenuItem-root': {
                fontFamily: 'Clancy, sans-serif',
                justifyContent: 'center',
                '&:hover': {
                  backgroundColor: '#FFFAE2',
                },
                '&.Mui-selected': {
                  backgroundColor: '#FFFAE2',
                  '&:hover': {
                    backgroundColor: '#FFFAE2',
                  },
                },
              },
              ...MenuProps?.PaperProps?.sx,
            },
          },
          ...MenuProps,
        }}
        {...props}
      />
    )
  },
)

export default MentemMuiSelect
